import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-secondary px-5 py-12 sm:py-20" data-id="element-26" data-mp="gx6mk1kjg47t">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="vtflt34fihk8">
        <div className="mx-auto max-w-2xl text-center" data-id="element-28" data-mp="vu7fg8egu57v">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-29" data-mp="qtjqds9sryga">
            🎁 5 bonusów dla małych konstruktorów. W zestawie już dziś
          </h2>
          <p className="mt-3 text-sm text-foreground/70 sm:text-base" data-id="element-30" data-mp="zureximihkx6">
            Więcej pomysłów, mniej przygotowań i prostszy sposób, żeby ciekawość nie gasła.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-31" data-mp="19kkn09ng3hwo">
          {bonuses.map((bonus, i) => <motion.article key={bonus.badge} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex flex-col rounded-2xl border border-primary/15 bg-card p-6 shadow-sm shadow-foreground/5 sm:p-7 md:last:col-span-2" data-id="element-32" data-mp="1njkbnhayjwsu" data-mpi={i}>
              <span className="w-fit rounded-md bg-foreground px-2.5 py-1 text-[11px] font-bold tracking-wide text-card" data-id="element-33" data-mp="2kug08wydb2o">
                {bonus.badge}
              </span>
              <h3 className="mt-4 text-base font-bold leading-snug text-foreground sm:text-lg" data-id="element-34" data-mp="cklfkp0deg9m">
                {bonus.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground/70" data-id="element-35" data-mp="gjkdvqrljes3">
                {bonus.description}
              </p>
              <div className="mt-5 flex items-center" data-id="element-36" data-mp="qax64jhb46yn">
                <span className="rounded-full bg-highlight px-3 py-1 text-xs font-bold text-foreground" data-id="element-37" data-mp="qaf1aygkwkf4">
                  W ZESTAWIE
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}